var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCredentialsLarge(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "70px",
    height: "62px",
    viewBox: "0 0 70 62",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Credentials") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_Atoms",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a/icons/micro/70/credentials-Final",
    transform: "translate(0.000000, -3.000000)",
    stroke: "#D8D8DE",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Credentials",
    transform: "translate(0.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "shape",
    x: 1,
    y: 12.5065373,
    width: 68,
    height: 47.4934627,
    rx: 5.3030303
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0909091,34.6976767 C22.0364278,34.6976767 24.7030944,35.891584 26.6333814,37.821871 C28.5636684,39.752158 29.7575758,42.4188247 29.7575758,45.3643434 L29.7575758,45.3643434 L29.7575758,50.5995674 L8.42424242,50.5995674 L8.42424242,45.3643434 C8.42424242,42.4188247 9.61814976,39.752158 11.5484368,37.821871 C13.4787238,35.891584 16.1453904,34.6976767 19.0909091,34.6976767 Z",
    id: "body"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "head",
    fill: "#EEF0F3",
    cx: 19.0909091,
    cy: 27.3793623,
    rx: 5.36363636,
    ry: 5.31831438
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.6515152,25.7997837 L53.5606061,25.7997837 M37.6515152,34.2242029 L63.1060606,34.2242029 M37.6515152,42.6486221 L63.1060606,42.6486221 M37.6515152,51.0730412 L63.1060606,51.0730412",
    id: "lines",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-19",
    fill: "#EEF0F3",
    points: "26.7094747 0 44.1368933 0 39.432074 17.2553621 31.2576826 17.2553621"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCredentialsLarge);
export default __webpack_public_path__ + "static/media/credentials-large.a5389e90d3a4ca1216c9de40abfb8f7c.svg";
export { ForwardRef as ReactComponent };